// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "public/js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"59":"f8511323","125":"358e2805","258":"fd96f3dd","382":"33ddc44d","443":"c02d097e","484":"cbc353d6","495":"8f842d83","503":"603546b6","549":"3f32b416","581":"d534ca5e","692":"51c034f9","772":"a3dc700d","817":"e37a7da0","842":"e9b1b167"}[chunkId] + ".js";
};